import Placeholder from 'assets/img/covers/placeholder.jpg';
import PropTypes from 'prop-types';
import React from 'react';
import { FiArrowRight } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import * as Ui from './BannerCustomerPreview.styles';

const BannerCustomerPreview = ({ media, name }) => {
  const { t } = useTranslation('app');
  const previewName = name?.trim() || t('mediaCrop.bannerNameFallback');

  return (
    <Ui.ResponsivePreview>
      <Ui.Section>
        <Ui.Frame>
          <Ui.PreviewImage
            src={media || Placeholder}
            alt={media ? previewName : t('mediaCrop.bannerPreviewAlt')}
          />
          <Ui.Overlay />
          <Ui.Content>
            <Ui.Title>{previewName}</Ui.Title>
            <Ui.Cta>
              {t('mediaCrop.bannerCta')}
              <Ui.CtaIcon>
                <FiArrowRight aria-hidden="true" focusable="false" />
              </Ui.CtaIcon>
            </Ui.Cta>
          </Ui.Content>
        </Ui.Frame>
      </Ui.Section>
    </Ui.ResponsivePreview>
  );
};

BannerCustomerPreview.propTypes = {
  media: PropTypes.string,
  name: PropTypes.string,
};

export default BannerCustomerPreview;
